import { Model } from '@vuex-orm/core';
import http from '@/services/http';

export default class AccountUserAttribute extends Model {
  static entity = 'account_user_attributes';

  static primaryKey = 'id';

  // FIELDS //////////////////////
  static fields() {
    return {
      id: this.attr(null),
      accountId: this.attr(null),
      userAttributeId: this.attr(null)
    };
  }

  // STATE //////////////////////
  static state() {
    return {
      updating: false
    };
  }

  static $state() {
    return this.store().state.entities.account_user_attributes;
  }

  static async updateAccountAttributes(accountId, userAttributeIds) {
    try {
      this.commit((state) => {
        state.updating = true;
      });

      const { data } = await http.put(`accounts/${accountId}/user_attributes`, {
        account: { userAttributeIds }
      });

      // This route doesn't return AccountUserAttributes records, so there is nothing to update or insert
      // If we need to adjust this in the future, we'll need to manually build and insert the records

      return data;
    }
    catch (error) {
      throw error;
    }
    finally {
      this.commit((state) => {
        state.updating = false;
      });
    }
  }
}
